var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM11.1625 8.235L9.9125 14.1163C9.825 14.5413 9.94875 14.7825 10.2925 14.7825C10.535 14.7825 10.9012 14.695 11.15 14.475L11.04 14.995C10.6812 15.4275 9.89 15.7425 9.20875 15.7425C8.33 15.7425 7.95625 15.215 8.19875 14.0938L9.12125 9.75875C9.20125 9.3925 9.12875 9.26 8.7625 9.17125L8.19875 9.07L8.30125 8.59375L11.1637 8.235H11.1625ZM10 6.875C9.66848 6.875 9.35054 6.7433 9.11612 6.50888C8.8817 6.27446 8.75 5.95652 8.75 5.625C8.75 5.29348 8.8817 4.97554 9.11612 4.74112C9.35054 4.5067 9.66848 4.375 10 4.375C10.3315 4.375 10.6495 4.5067 10.8839 4.74112C11.1183 4.97554 11.25 5.29348 11.25 5.625C11.25 5.95652 11.1183 6.27446 10.8839 6.50888C10.6495 6.7433 10.3315 6.875 10 6.875Z",
    fill: "#1C2026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon2);
export default __webpack_public_path__ + "static/media/info-icon-2.fc15e3db20962e1c0b25669f66fe90d6.svg";
export { ForwardRef as ReactComponent };